import { useState } from "react";
import { X, Zap, Check } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { usePlan, PlanPrice } from "@/lib/plan";
import { useI18n } from "@/context/I18nContext";


export default function Paywall({ open, onClose, reason }) {
  const [loading, setLoading] = useState(false);
  const plan = usePlan();
  const { t } = useI18n();

  if (!open) return null;

  const upgrade = async () => {
    setLoading(true);
    try {
      const res = await api.post("/billing/checkout", { origin_url: window.location.origin });
      window.location.href = res.data.url;
    } catch (e) {
      toast.error(t("pm.paywall.checkoutFailed"));
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm" data-testid="paywall-modal">
      <div className="nb-card max-w-md w-full p-0 overflow-hidden animate-pop-in shadow-hard-lg">
        <div className="bg-coral text-white p-6 border-b-2 border-ink relative">
          <button onClick={onClose} className="absolute top-4 end-4" data-testid="paywall-close" aria-label={t("pm.library.close")}>
            <X className="w-6 h-6" />
          </button>
          <div className="nb-tag bg-white text-ink mb-3" data-testid="paywall-plan-name">{plan?.name || "GetFluentLoop Pro"}</div>
          <h2 className="font-cabinet font-extrabold text-3xl"><span dir="ltr" className="inline-block"><PlanPrice plan={plan} unitClass="text-lg font-bold" unit={plan?.interval === "month" ? t("pm.paywall.month") : undefined} /></span></h2>
          <p className="text-white/90 text-sm mt-1">{reason || t("pm.paywall.tagline")}</p>
        </div>
        <div className="p-6 bg-white">
          <ul className="space-y-3">
            {t("pm.paywall.benefits").map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-md bg-mint border-2 border-ink flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 stroke-[3]" />
                </span>
                <span className="text-sm font-medium">{p}</span>
              </li>
            ))}
          </ul>
          <button onClick={upgrade} disabled={loading} data-testid="paywall-upgrade-btn"
            className="nb-btn-primary w-full mt-6 py-3 text-lg">
            <Zap className="w-5 h-5" /> {loading ? t("pm.paywall.starting") : t("pm.paywall.subscribe")}
          </button>
          <button onClick={onClose} className="w-full mt-2 text-sm text-gray-500 hover:text-ink py-2" data-testid="paywall-later">
            {t("pm.paywall.later")}
          </button>
        </div>
      </div>
    </div>
  );
}
